import type { ArmSpec } from '../armRegistry';
import { isDownloadRead } from '../openerIntent';

const DOWNLOAD_LINE = 'Your PDF, one tap.';

// Empty strings win the per-page shallow merge and collapse cleanly behind
// ButtonsPage's truthiness guards. ONLY ButtonsPage is quieted: the email
// pages render header/subheader unguarded (an empty header leaves a padded
// blank element), and their defaults are page titles and instructions, not
// persuasion. disclaimerVerb, submit, every button label, and the legal
// sentence stay untouched by construction (never keyed here). The permitted
// d/r line rides the SUBHEADER: the paper-card layout never renders
// buttonsPage.header, and the subheader renders on both layouts.
export const quietModeSpec: ArmSpec = {
  configuredTextOverride: (ctx) => ({
    buttonsPage: {
      header: '',
      subheader: isDownloadRead(ctx.detail) ? DOWNLOAD_LINE : '',
    },
  }),
};
